var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppDialog",
    {
      attrs: {
        activatorText: "Import",
        title: "Import an Anonymization Config",
        action: "Import",
        "action-disabled":
          !this.name ||
          !this.file ||
          _vm.existingConfigNames.includes(this.name)
      },
      on: {
        action: function($event) {
          return _vm.handleImport()
        }
      }
    },
    [
      _c("v-text-field", {
        attrs: {
          label: "Name",
          solo: "",
          rules: [
            function() {
              return (
                !_vm.existingConfigNames.includes(this$1.name) ||
                "Name Already Taken!"
              )
            }
          ]
        },
        model: {
          value: _vm.name,
          callback: function($$v) {
            _vm.name = $$v
          },
          expression: "name"
        }
      }),
      _vm._v(" "),
      _c("v-file-input", {
        attrs: {
          label: "Anonymization Config JSON",
          accept: "application/json",
          "hide-details": "",
          solo: ""
        },
        on: { change: _vm.handleJSONUpload },
        model: {
          value: _vm.file,
          callback: function($$v) {
            _vm.file = $$v
          },
          expression: "file"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }